import { z } from "zod";

export const timestampSchema = z.string().or(z.null());

export const smartViewRecordSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  smart_context_id: z.string(),
  derived_kind: z.string().nullable(),
  derived_internal_label: z.string().nullable(),
  value_json: z.unknown().nullable(),
  has_found_more: z.boolean(),
  refreshed_at: timestampSchema,
  created_at: timestampSchema,
  updated_at: timestampSchema,
});

export const smartViewUpsertSchema = z.object({
  id: z.string(),
  associated_space_account_id: z.string(),
  smart_context_id: z.string(),
  derived_kind: z.string().nullish(),
  derived_internal_label: z.string().nullish(),
  value_json: z.unknown().optional(),
  has_found_more: z.boolean().optional(),
  refreshed_at: timestampSchema.nullish(),
  created_at: timestampSchema.nullish(),
  updated_at: timestampSchema.nullish(),
});

export type SmartViewRow = z.infer<typeof smartViewRecordSchema>;
export type SmartViewUpsertInput = z.input<typeof smartViewUpsertSchema>;
